module.exports = __webpack_public_path__ + "theme/fonts/element-icons.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/element-ui/lib/theme-chalk/fonts/element-icons.ttf
// module id = 336
// module chunks = 0